import api from "../../utils/apiUser";
import { desempaquetarLista } from "../../utils/listaPaginada";

export const getProductos = async ({ limit = 500, offset = 0 } = {}) => {
  const res = await api.get("/api/productos", { params: { limit, offset } });
  return desempaquetarLista(res.data);
};

export const getProductoById = async (id) => {
  const res = await api.get(`/api/productos/${id}`);
  return res.data;
};

/**
 * Busca un producto por su codigo de barras (lo que teclea la pistola).
 * Devuelve null si no hay coincidencia, para que la vista distinga
 * "no existe" de un error de red.
 */
export const getProductoPorCodigo = async (codigo) => {
  const limpio = String(codigo ?? "").trim();
  if (!limpio) return null;

  try {
    const res = await api.get(`/api/productos/barcode/${encodeURIComponent(limpio)}`);
    return res.data?.producto ?? null;
  } catch (err) {
    if (err?.status === 404 || err?.response?.status === 404) return null;
    throw err;
  }
};

export const crearProducto = async (formData) => {
  const res = await api.post("/api/productos", formData, {
    headers: { "Content-Type": "multipart/form-data" },
  });
  return res.data;
};

export const actualizarProducto = async (id, formData) => {
  const res = await api.put(`/api/productos/${id}`, formData, {
    headers: { "Content-Type": "multipart/form-data" },
  });
  return res.data;
};
